import RichText from 'components/RichText';
import Text from 'components/Text';
import { cn } from 'utils/classNames';

interface Props {
	className?: string;
	text: string;
	title: string;
}

/** Title and text on a background */
export default function MicroContentText({ className, text, title }: Props) {
	return (
		<Text
			as="div"
			className={cn(
				'rounded-xs bg-subtle px-4 py-6 text-md sm:px-6 sm:py-8 forced-colors:border',
				// The Text component has overflow-wrap but it doesn't always work
				// in Chrome as of september 2025. The broken example is long words
				// inside a ul > li in the rich text.
				// `word-break: break-word` is deprecated but solves the issue and
				// will probably stick around for a long while.
				'[word-break:break-word]',
				className,
			)}
		>
			<p className="mb-2 font-bold">{title}</p>
			<RichText html={text} className="max-sm:text-sm" />
		</Text>
	);
}
MicroContentText.displayName = 'MicroContentText';
